var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Reference",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.lead.leadReference,
                          callback: function($$v) {
                            _vm.$set(_vm.lead, "leadReference", $$v)
                          },
                          expression: "lead.leadReference"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "First name",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.lead.leadFirstName,
                          callback: function($$v) {
                            _vm.$set(_vm.lead, "leadFirstName", $$v)
                          },
                          expression: "lead.leadFirstName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Last name",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.lead.leadLastName,
                          callback: function($$v) {
                            _vm.$set(_vm.lead, "leadLastName", $$v)
                          },
                          expression: "lead.leadLastName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Email",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.lead.leadEmail,
                          callback: function($$v) {
                            _vm.$set(_vm.lead, "leadEmail", $$v)
                          },
                          expression: "lead.leadEmail"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Contact number",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.lead.leadContact1,
                          callback: function($$v) {
                            _vm.$set(_vm.lead, "leadContact1", $$v)
                          },
                          expression: "lead.leadContact1"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }